import { QueryClient } from '@tanstack/react-query';
import { ProductEntity } from 'src/entities/ProductEntity';
import { queryKey } from 'src/hooks/useProducts.request';

export class ProjectCache {
  constructor(private queryClient: QueryClient) {}

  update(entity: ProductEntity) {
    const projectCache = this.queryClient.getQueriesData({ queryKey: [queryKey] });
    projectCache.forEach(([queryCacheKey, queryData]) => {
      if (typeof queryData === 'object' && 'id' in queryData) {
        const productEntity = queryData as ProductEntity;
        if (productEntity.id === entity.id) {
          this.queryClient.setQueryData(queryCacheKey, entity);
        }
      } else if (typeof queryData === 'object' && 'data' in queryData) {
        const cacheData = queryData as { data: ProductEntity[] };
        const newPages = cacheData.data.map((page) => {
          if (page.id === entity.id) {
            return entity;
          }
          return page;
        });
        this.queryClient.setQueryData(queryCacheKey, { ...cacheData, data: newPages });
      }
    });
  }
}
